import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// French translations (Default for Tunisia)
const frTranslations = {
  common: {
    welcome: 'Bienvenue',
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    login: 'Connexion',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    import: 'Importer',
    print: 'Imprimer',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    actions: 'Actions',
    status: 'Statut',
    date: 'Date',
    amount: 'Montant',
    total: 'Total',
    subtotal: 'Sous-total',
    tax: 'TVA',
    discount: 'Remise',
    currency: 'TND',
    yes: 'Oui',
    no: 'Non',
    all: 'Tous',
    active: 'Actif',
    inactive: 'Inactif',
    draft: 'Brouillon',
    confirmed: 'Confirmé',
    cancelled: 'Annulé',
    pending: 'En attente',
    completed: 'Terminé',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information',
  },
  auth: {
    email: 'Adresse email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    resetPassword: 'Réinitialiser le mot de passe',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    signOut: 'Se déconnecter',
    rememberMe: 'Se souvenir de moi',
    invalidCredentials: 'Email ou mot de passe incorrect',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
  },
  modules: {
    accounting: 'Comptabilité',
    sales: 'Ventes',
    purchase: 'Achats',
    inventory: 'Inventaire',
    hr: 'Ressources Humaines',
    manufacturing: 'Fabrication',
    pos: 'Point de Vente',
    projects: 'Projets',
    documents: 'Documents',
    partners: 'Partenaires',
  },
  accounting: {
    chartOfAccounts: 'Plan comptable',
    journalEntries: 'Écritures comptables',
    generalLedger: 'Grand livre',
    trialBalance: 'Balance des comptes',
    incomeStatement: 'Compte de résultat',
    balanceSheet: 'Bilan',
    fiscalYear: 'Exercice fiscal',
    account: 'Compte',
    accountCode: 'Code compte',
    accountName: 'Nom du compte',
    accountType: 'Type de compte',
    debit: 'Débit',
    credit: 'Crédit',
    balance: 'Solde',
    journal: 'Journal',
    reference: 'Référence',
    description: 'Description',
    taxes: 'Taxes',
    tvaCollectee: 'TVA Collectée',
    tvaDeductible: 'TVA Déductible',
    tvaRate: 'Taux TVA',
    retenuSource: 'Retenue à la source',
    timbreFiscal: 'Timbre fiscal',
  },
  sales: {
    quotation: 'Devis',
    quotations: 'Devis',
    salesOrder: 'Bon de commande',
    salesOrders: 'Bons de commande',
    invoice: 'Facture',
    invoices: 'Factures',
    delivery: 'Bon de livraison',
    deliveries: 'Bons de livraison',
    customer: 'Client',
    customers: 'Clients',
    orderDate: 'Date de commande',
    deliveryDate: 'Date de livraison',
    dueDate: 'Date d\'échéance',
    paymentTerms: 'Conditions de paiement',
    product: 'Article',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    lineTotal: 'Total ligne',
  },
  purchase: {
    purchaseRequest: 'Demande d\'achat',
    purchaseOrder: 'Bon de commande',
    purchaseOrders: 'Bons de commande',
    supplierInvoice: 'Facture fournisseur',
    reception: 'Réception',
    supplier: 'Fournisseur',
    suppliers: 'Fournisseurs',
    vendor: 'Fournisseur',
    orderDate: 'Date de commande',
    expectedDate: 'Date prévue',
    receivedDate: 'Date de réception',
  },
  inventory: {
    products: 'Articles',
    product: 'Article',
    category: 'Catégorie',
    categories: 'Catégories',
    units: 'Unités de mesure',
    warehouse: 'Entrepôt',
    warehouses: 'Entrepôts',
    location: 'Emplacement',
    locations: 'Emplacements',
    stockMove: 'Mouvement de stock',
    stockMoves: 'Mouvements de stock',
    lot: 'Lot',
    lots: 'Lots',
    serialNumber: 'Numéro de série',
    quantity: 'Quantité',
    available: 'Disponible',
    reserved: 'Réservé',
    onHand: 'En stock',
    reorderLevel: 'Seuil de réapprovisionnement',
    internalReference: 'Référence interne',
    barcode: 'Code-barres',
    unitOfMeasure: 'Unité de mesure',
  },
  hr: {
    employees: 'Employés',
    employee: 'Employé',
    contracts: 'Contrats',
    contract: 'Contrat',
    payroll: 'Paie',
    payslip: 'Bulletin de paie',
    payslips: 'Bulletins de paie',
    leaves: 'Congés',
    leave: 'Congé',
    attendance: 'Présence',
    departments: 'Départements',
    department: 'Département',
    positions: 'Postes',
    position: 'Poste',
    salary: 'Salaire',
    grossSalary: 'Salaire brut',
    netSalary: 'Salaire net',
    cnss: 'CNSS',
    cnssEmployee: 'CNSS Salarié (9.18%)',
    cnssEmployer: 'CNSS Patronale (16.57%)',
    irpp: 'IRPP',
    smig: 'SMIG',
    hireDate: 'Date d\'embauche',
    endDate: 'Date de fin',
    contractType: 'Type de contrat',
    cdi: 'CDI',
    cdd: 'CDD',
    intern: 'Stage',
    leaveTypes: {
      annual: 'Congé annuel',
      sick: 'Congé maladie',
      maternity: 'Congé maternité',
      paternity: 'Congé paternité',
      marriage: 'Congé mariage',
      bereavement: 'Congé décès',
      unpaid: 'Congé sans solde',
    },
  },
  manufacturing: {
    billOfMaterials: 'Nomenclature',
    bom: 'Nomenclature',
    boms: 'Nomenclatures',
    workCenter: 'Centre de travail',
    workCenters: 'Centres de travail',
    manufacturingOrder: 'Ordre de fabrication',
    manufacturingOrders: 'Ordres de fabrication',
    routing: 'Gamme',
    operation: 'Opération',
    operations: 'Opérations',
    plannedQty: 'Quantité planifiée',
    producedQty: 'Quantité produite',
    startDate: 'Date de début',
    endDate: 'Date de fin',
  },
  pos: {
    pointOfSale: 'Point de vente',
    session: 'Session',
    sessions: 'Sessions',
    openSession: 'Ouvrir la session',
    closeSession: 'Fermer la session',
    order: 'Commande',
    orders: 'Commandes',
    payment: 'Paiement',
    payments: 'Paiements',
    cash: 'Espèces',
    card: 'Carte',
    check: 'Chèque',
    openingBalance: 'Solde d\'ouverture',
    closingBalance: 'Solde de fermeture',
    expectedAmount: 'Montant attendu',
    actualAmount: 'Montant réel',
    difference: 'Écart',
  },
  projects: {
    project: 'Projet',
    projects: 'Projets',
    task: 'Tâche',
    tasks: 'Tâches',
    timesheet: 'Feuille de temps',
    timesheets: 'Feuilles de temps',
    milestone: 'Jalon',
    milestones: 'Jalons',
    assignedTo: 'Assigné à',
    priority: 'Priorité',
    deadline: 'Échéance',
    progress: 'Progression',
    hoursSpent: 'Heures passées',
    hoursPlanned: 'Heures planifiées',
    billable: 'Facturable',
  },
  documents: {
    document: 'Document',
    documents: 'Documents',
    folder: 'Dossier',
    folders: 'Dossiers',
    upload: 'Télécharger',
    download: 'Télécharger',
    share: 'Partager',
    tag: 'Étiquette',
    tags: 'Étiquettes',
    version: 'Version',
    versions: 'Versions',
    size: 'Taille',
    type: 'Type',
    uploadedBy: 'Téléchargé par',
    uploadedAt: 'Téléchargé le',
  },
  partners: {
    partner: 'Partenaire',
    partners: 'Partenaires',
    contact: 'Contact',
    contacts: 'Contacts',
    address: 'Adresse',
    addresses: 'Adresses',
    company: 'Société',
    individual: 'Particulier',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    mobile: 'Mobile',
    website: 'Site web',
    taxId: 'Matricule fiscal',
    rne: 'RNE',
    vatNumber: 'N° TVA',
    city: 'Ville',
    country: 'Pays',
    postalCode: 'Code postal',
    street: 'Rue',
    isCustomer: 'Client',
    isSupplier: 'Fournisseur',
    creditLimit: 'Limite de crédit',
    paymentTerms: 'Conditions de paiement',
  },
  tunisia: {
    governorates: {
      tunis: 'Tunis',
      ariana: 'Ariana',
      benArous: 'Ben Arous',
      manouba: 'Manouba',
      nabeul: 'Nabeul',
      zaghouan: 'Zaghouan',
      bizerte: 'Bizerte',
      beja: 'Béja',
      jendouba: 'Jendouba',
      kef: 'Le Kef',
      siliana: 'Siliana',
      sousse: 'Sousse',
      monastir: 'Monastir',
      mahdia: 'Mahdia',
      sfax: 'Sfax',
      kairouan: 'Kairouan',
      kasserine: 'Kasserine',
      sidiBouzid: 'Sidi Bouzid',
      gabes: 'Gabès',
      medenine: 'Médenine',
      tataouine: 'Tataouine',
      gafsa: 'Gafsa',
      tozeur: 'Tozeur',
      kebili: 'Kébili',
    },
    matriculeFiscal: 'Matricule Fiscal',
    rne: 'Registre National des Entreprises',
    cnss: 'CNSS',
    irpp: 'IRPP',
    tva: 'TVA',
    timbre: 'Timbre Fiscal',
    fodec: 'FODEC',
  },
  validation: {
    required: 'Ce champ est obligatoire',
    email: 'Veuillez entrer une adresse email valide',
    minLength: 'Minimum {{min}} caractères requis',
    maxLength: 'Maximum {{max}} caractères autorisés',
    min: 'La valeur minimum est {{min}}',
    max: 'La valeur maximum est {{max}}',
    numeric: 'Ce champ doit être un nombre',
    positive: 'Ce champ doit être positif',
    phone: 'Veuillez entrer un numéro de téléphone valide',
    matriculeFiscal: 'Format de matricule fiscal invalide',
    date: 'Veuillez entrer une date valide',
    dateRange: 'La date de fin doit être après la date de début',
  },
  messages: {
    saveSuccess: 'Enregistrement réussi',
    saveError: 'Erreur lors de l\'enregistrement',
    deleteSuccess: 'Suppression réussie',
    deleteError: 'Erreur lors de la suppression',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    updateSuccess: 'Mise à jour réussie',
    updateError: 'Erreur lors de la mise à jour',
    loadError: 'Erreur lors du chargement des données',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action',
    sessionExpired: 'Votre session a expiré',
    networkError: 'Erreur de connexion réseau',
  },
};

// Arabic translations
const arTranslations = {
  common: {
    welcome: 'مرحبا',
    dashboard: 'لوحة القيادة',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    print: 'طباعة',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    actions: 'إجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    amount: 'المبلغ',
    total: 'المجموع',
    subtotal: 'المجموع الفرعي',
    tax: 'الضريبة',
    discount: 'الخصم',
    currency: 'د.ت',
    yes: 'نعم',
    no: 'لا',
    all: 'الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    draft: 'مسودة',
    confirmed: 'مؤكد',
    cancelled: 'ملغى',
    pending: 'قيد الانتظار',
    completed: 'مكتمل',
    error: 'خطأ',
    success: 'نجاح',
    warning: 'تحذير',
    info: 'معلومات',
  },
  auth: {
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    signOut: 'تسجيل الخروج',
    rememberMe: 'تذكرني',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    sessionExpired: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
  },
  modules: {
    accounting: 'المحاسبة',
    sales: 'المبيعات',
    purchase: 'المشتريات',
    inventory: 'المخزون',
    hr: 'الموارد البشرية',
    manufacturing: 'التصنيع',
    pos: 'نقطة البيع',
    projects: 'المشاريع',
    documents: 'المستندات',
    partners: 'الشركاء',
  },
  accounting: {
    chartOfAccounts: 'شجرة الحسابات',
    journalEntries: 'القيود المحاسبية',
    generalLedger: 'دفتر الأستاذ',
    trialBalance: 'ميزان المراجعة',
    incomeStatement: 'قائمة الدخل',
    balanceSheet: 'الميزانية العمومية',
    fiscalYear: 'السنة المالية',
    account: 'حساب',
    accountCode: 'رمز الحساب',
    accountName: 'اسم الحساب',
    accountType: 'نوع الحساب',
    debit: 'مدين',
    credit: 'دائن',
    balance: 'الرصيد',
    journal: 'يومية',
    reference: 'المرجع',
    description: 'الوصف',
    taxes: 'الضرائب',
    tvaCollectee: 'الأداء على القيمة المضافة المجموعة',
    tvaDeductible: 'الأداء على القيمة المضافة القابل للخصم',
    tvaRate: 'نسبة الأداء',
    retenuSource: 'الخصم من المنبع',
    timbreFiscal: 'الطابع الجبائي',
  },
  sales: {
    quotation: 'عرض أسعار',
    quotations: 'عروض الأسعار',
    salesOrder: 'طلب مبيعات',
    salesOrders: 'طلبات المبيعات',
    invoice: 'فاتورة',
    invoices: 'الفواتير',
    delivery: 'إذن تسليم',
    deliveries: 'أذونات التسليم',
    customer: 'عميل',
    customers: 'العملاء',
    orderDate: 'تاريخ الطلب',
    deliveryDate: 'تاريخ التسليم',
    dueDate: 'تاريخ الاستحقاق',
    paymentTerms: 'شروط الدفع',
    product: 'منتج',
    quantity: 'الكمية',
    unitPrice: 'سعر الوحدة',
    lineTotal: 'إجمالي السطر',
  },
  purchase: {
    purchaseRequest: 'طلب شراء',
    purchaseOrder: 'أمر شراء',
    purchaseOrders: 'أوامر الشراء',
    supplierInvoice: 'فاتورة المورد',
    reception: 'استلام',
    supplier: 'مورد',
    suppliers: 'الموردين',
    vendor: 'مورد',
    orderDate: 'تاريخ الطلب',
    expectedDate: 'التاريخ المتوقع',
    receivedDate: 'تاريخ الاستلام',
  },
  hr: {
    employees: 'الموظفون',
    employee: 'موظف',
    contracts: 'العقود',
    contract: 'عقد',
    payroll: 'الرواتب',
    payslip: 'قسيمة الراتب',
    payslips: 'قسائم الرواتب',
    leaves: 'الإجازات',
    leave: 'إجازة',
    attendance: 'الحضور',
    departments: 'الأقسام',
    department: 'قسم',
    positions: 'المناصب',
    position: 'منصب',
    salary: 'الراتب',
    grossSalary: 'الراتب الإجمالي',
    netSalary: 'صافي الراتب',
    cnss: 'CNSS',
    cnssEmployee: 'CNSS موظف (9.18%)',
    cnssEmployer: 'CNSS صاحب العمل (16.57%)',
    irpp: 'IRPP',
    smig: 'الأجر الأدنى',
    hireDate: 'تاريخ التوظيف',
    endDate: 'تاريخ الانتهاء',
    contractType: 'نوع العقد',
    cdi: 'عقد غير محدد المدة',
    cdd: 'عقد محدد المدة',
    intern: 'تدريب',
    leaveTypes: {
      annual: 'إجازة سنوية',
      sick: 'إجازة مرضية',
      maternity: 'إجازة أمومة',
      paternity: 'إجازة أبوة',
      marriage: 'إجازة زواج',
      bereavement: 'إجازة وفاة',
      unpaid: 'إجازة بدون راتب',
    },
  },
  tunisia: {
    governorates: {
      tunis: 'تونس',
      ariana: 'أريانة',
      benArous: 'بن عروس',
      manouba: 'منوبة',
      nabeul: 'نابل',
      zaghouan: 'زغوان',
      bizerte: 'بنزرت',
      beja: 'باجة',
      jendouba: 'جندوبة',
      kef: 'الكاف',
      siliana: 'سليانة',
      sousse: 'سوسة',
      monastir: 'المنستير',
      mahdia: 'المهدية',
      sfax: 'صفاقس',
      kairouan: 'القيروان',
      kasserine: 'القصرين',
      sidiBouzid: 'سيدي بوزيد',
      gabes: 'قابس',
      medenine: 'مدنين',
      tataouine: 'تطاوين',
      gafsa: 'قفصة',
      tozeur: 'توزر',
      kebili: 'قبلي',
    },
    matriculeFiscal: 'المعرف الجبائي',
    rne: 'السجل الوطني للمؤسسات',
    cnss: 'الصندوق الوطني للضمان الاجتماعي',
    irpp: 'الضريبة على الدخل',
    tva: 'الأداء على القيمة المضافة',
    timbre: 'الطابع الجبائي',
    fodec: 'صندوق تنمية القدرة التنافسية',
  },
  validation: {
    required: 'هذا الحقل مطلوب',
    email: 'يرجى إدخال بريد إلكتروني صحيح',
    minLength: 'الحد الأدنى {{min}} أحرف',
    maxLength: 'الحد الأقصى {{max}} أحرف',
    min: 'القيمة الدنيا هي {{min}}',
    max: 'القيمة القصوى هي {{max}}',
    numeric: 'يجب أن يكون رقماً',
    positive: 'يجب أن يكون موجباً',
    phone: 'يرجى إدخال رقم هاتف صحيح',
    matriculeFiscal: 'صيغة المعرف الجبائي غير صحيحة',
    date: 'يرجى إدخال تاريخ صحيح',
    dateRange: 'تاريخ الانتهاء يجب أن يكون بعد تاريخ البدء',
  },
  messages: {
    saveSuccess: 'تم الحفظ بنجاح',
    saveError: 'خطأ في الحفظ',
    deleteSuccess: 'تم الحذف بنجاح',
    deleteError: 'خطأ في الحذف',
    deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر؟',
    updateSuccess: 'تم التحديث بنجاح',
    updateError: 'خطأ في التحديث',
    loadError: 'خطأ في تحميل البيانات',
    unauthorized: 'غير مصرح لك بتنفيذ هذا الإجراء',
    sessionExpired: 'انتهت صلاحية جلستك',
    networkError: 'خطأ في الاتصال بالشبكة',
  },
};

// English translations
const enTranslations = {
  common: {
    welcome: 'Welcome',
    dashboard: 'Dashboard',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    amount: 'Amount',
    total: 'Total',
    subtotal: 'Subtotal',
    tax: 'Tax',
    discount: 'Discount',
    currency: 'TND',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    pending: 'Pending',
    completed: 'Completed',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
  },
  auth: {
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signOut: 'Sign out',
    rememberMe: 'Remember me',
    invalidCredentials: 'Invalid email or password',
    sessionExpired: 'Your session has expired. Please sign in again.',
  },
  modules: {
    accounting: 'Accounting',
    sales: 'Sales',
    purchase: 'Purchase',
    inventory: 'Inventory',
    hr: 'Human Resources',
    manufacturing: 'Manufacturing',
    pos: 'Point of Sale',
    projects: 'Projects',
    documents: 'Documents',
    partners: 'Partners',
  },
  accounting: {
    chartOfAccounts: 'Chart of Accounts',
    journalEntries: 'Journal Entries',
    generalLedger: 'General Ledger',
    trialBalance: 'Trial Balance',
    incomeStatement: 'Income Statement',
    balanceSheet: 'Balance Sheet',
    fiscalYear: 'Fiscal Year',
    account: 'Account',
    accountCode: 'Account Code',
    accountName: 'Account Name',
    accountType: 'Account Type',
    debit: 'Debit',
    credit: 'Credit',
    balance: 'Balance',
    journal: 'Journal',
    reference: 'Reference',
    description: 'Description',
    taxes: 'Taxes',
    tvaCollectee: 'Output VAT',
    tvaDeductible: 'Input VAT',
    tvaRate: 'VAT Rate',
    retenuSource: 'Withholding Tax',
    timbreFiscal: 'Stamp Duty',
  },
  sales: {
    quotation: 'Quotation',
    quotations: 'Quotations',
    salesOrder: 'Sales Order',
    salesOrders: 'Sales Orders',
    invoice: 'Invoice',
    invoices: 'Invoices',
    delivery: 'Delivery Note',
    deliveries: 'Delivery Notes',
    customer: 'Customer',
    customers: 'Customers',
    orderDate: 'Order Date',
    deliveryDate: 'Delivery Date',
    dueDate: 'Due Date',
    paymentTerms: 'Payment Terms',
    product: 'Product',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    lineTotal: 'Line Total',
  },
  purchase: {
    purchaseRequest: 'Purchase Request',
    purchaseOrder: 'Purchase Order',
    purchaseOrders: 'Purchase Orders',
    supplierInvoice: 'Supplier Invoice',
    reception: 'Reception',
    supplier: 'Supplier',
    suppliers: 'Suppliers',
    vendor: 'Vendor',
    orderDate: 'Order Date',
    expectedDate: 'Expected Date',
    receivedDate: 'Received Date',
  },
  hr: {
    employees: 'Employees',
    employee: 'Employee',
    contracts: 'Contracts',
    contract: 'Contract',
    payroll: 'Payroll',
    payslip: 'Payslip',
    payslips: 'Payslips',
    leaves: 'Leaves',
    leave: 'Leave',
    attendance: 'Attendance',
    departments: 'Departments',
    department: 'Department',
    positions: 'Positions',
    position: 'Position',
    salary: 'Salary',
    grossSalary: 'Gross Salary',
    netSalary: 'Net Salary',
    cnss: 'CNSS',
    cnssEmployee: 'CNSS Employee (9.18%)',
    cnssEmployer: 'CNSS Employer (16.57%)',
    irpp: 'IRPP',
    smig: 'Minimum Wage',
    hireDate: 'Hire Date',
    endDate: 'End Date',
    contractType: 'Contract Type',
    cdi: 'Permanent',
    cdd: 'Fixed-term',
    intern: 'Internship',
    leaveTypes: {
      annual: 'Annual Leave',
      sick: 'Sick Leave',
      maternity: 'Maternity Leave',
      paternity: 'Paternity Leave',
      marriage: 'Marriage Leave',
      bereavement: 'Bereavement Leave',
      unpaid: 'Unpaid Leave',
    },
  },
  tunisia: {
    governorates: {
      tunis: 'Tunis',
      ariana: 'Ariana',
      benArous: 'Ben Arous',
      manouba: 'Manouba',
      nabeul: 'Nabeul',
      zaghouan: 'Zaghouan',
      bizerte: 'Bizerte',
      beja: 'Béja',
      jendouba: 'Jendouba',
      kef: 'Le Kef',
      siliana: 'Siliana',
      sousse: 'Sousse',
      monastir: 'Monastir',
      mahdia: 'Mahdia',
      sfax: 'Sfax',
      kairouan: 'Kairouan',
      kasserine: 'Kasserine',
      sidiBouzid: 'Sidi Bouzid',
      gabes: 'Gabès',
      medenine: 'Médenine',
      tataouine: 'Tataouine',
      gafsa: 'Gafsa',
      tozeur: 'Tozeur',
      kebili: 'Kébili',
    },
    matriculeFiscal: 'Tax ID',
    rne: 'National Business Registry',
    cnss: 'Social Security Fund',
    irpp: 'Personal Income Tax',
    tva: 'Value Added Tax',
    timbre: 'Stamp Duty',
    fodec: 'Competitiveness Development Fund',
  },
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    minLength: 'Minimum {{min}} characters required',
    maxLength: 'Maximum {{max}} characters allowed',
    min: 'Minimum value is {{min}}',
    max: 'Maximum value is {{max}}',
    numeric: 'This field must be a number',
    positive: 'This field must be positive',
    phone: 'Please enter a valid phone number',
    matriculeFiscal: 'Invalid tax ID format',
    date: 'Please enter a valid date',
    dateRange: 'End date must be after start date',
  },
  messages: {
    saveSuccess: 'Saved successfully',
    saveError: 'Error saving',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Error deleting',
    deleteConfirm: 'Are you sure you want to delete this item?',
    updateSuccess: 'Updated successfully',
    updateError: 'Error updating',
    loadError: 'Error loading data',
    unauthorized: 'You are not authorized to perform this action',
    sessionExpired: 'Your session has expired',
    networkError: 'Network connection error',
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      ar: { translation: arTranslations },
      en: { translation: enTranslations },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'ar', 'en'],
    
    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Update document direction for RTL languages
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
